import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { fetchClient, fetchUserData, fetchUsers, confirmationRequest, setPageTitle, updateProfile } from '../../actions';
import { Page } from '../../components';
import Box from '../../components/layout/Box';
import Button from '../../components/widgets/Button';
import { getProfile, } from '../../selectors/profile';
import './styles.scss';

// for client
import PermissionModal from '../../components/widgets/PermissionModal';
import { Icon, Switch } from '../../components/widgets';
import { Link } from 'react-router-dom';
import {
  getClient, getUsers, getProfileUser, isFetching, isFetchingProfileUser
} from 'signoxe/selectors';
import { SUBUSER_RESOURCE } from '../../api/resources';
import _ from 'lodash';


class UserProfilePage extends React.Component {
  static propTypes = {
    updateProfile: PropTypes.func.isRequired,
    setPageTitle: PropTypes.func.isRequired,
    clientProfile: PropTypes.array.isRequired,
    users: PropTypes.array.isRequired,


  };

  constructor(props) {
    super(props);
    console.log("Props profile page clientProfile", props.clientProfile);

    this.state = {
      user: null,
      singleUser: null,
      createUser: false,
      
      visible: false,

      reset: false,
      editMial: false,
      editUserName: false,
      editFirstName: false,
      editLastName: false,

      currentUserReset: false, 
      currentUserEditMial: false, 
      currentUserEditUserName: false, 
      currentUserEditFirstName: false, 
      currentUserEditLastName: false,
      
      Toggle_two_factor_authentication: false,
      two_factor_authentication: null,

      Toggle_display_device_logo: false,
      display_device_logo: null,
      Triger_add_logo:false,
      newLogo: null,
      newLogo_name:null,

      client_id:null,
      
      clientProfile: props.clientProfile,

    }
    this.handleCancel = this.handleCancel.bind(this)
  }
  

  componentDidMount() {
    this.props.fetchClient()
    this.props.fetchUserData()
    this.props.fetchUsers()
    
    if (this.props.clientProfile) {
      this.props.setPageTitle(`${this.props.clientProfile.profile.name} Profile`);
    }
  }

  handleCancel() {
    this.setState({ 
      visible: false, createUser: false,

      user: null, reset: false, editMial: false, editUserName:false, editFirstName:false, editLastName:false, 

      singleUser: null, currentUserReset: false, currentUserEditMial: false, 
      currentUserEditUserName: false, currentUserEditFirstName: false, currentUserEditLastName: false, 
      Toggle_two_factor_authentication: false, two_factor_authentication: null,
      Toggle_display_device_logo: false, display_device_logo: null,
      Triger_add_logo: false, newLogo: null, client_id:null,
    })
  }


  createSubUser(user) {
    this.setState({ visible: true, user, createUser: true })
  }

  editUserPerms(user) {
    this.setState({ visible: true, user })
  }

  resetPassword(user) {
    this.setState({ visible: true, user, reset: true })
  }

  
  resetEmail(user) {
    this.setState({ visible: true, user, editMial: true })
  }

  resetUsername(user) {
    this.setState({ visible: true, user, editUserName: true })
  }

  resetFirstName(user) {
    this.setState({ visible: true, user, editFirstName: true })
  }

  resetLastName(user) {
    this.setState({ visible: true, user, editLastName: true })
  }

  handleUserDelete = (user) =>
    this.props.confirmationRequest(
      'Deleting User',
      `Deleting the user "${user.username}".`,
      'DELETE',
      SUBUSER_RESOURCE,
      user.id,
    )

  resetCurrentUserPassword(singleUser) {
    this.setState({ visible: true, singleUser, currentUserReset: true })
  }
  
  resetCurrentUserEmail(singleUser) {
    this.setState({ visible: true, singleUser, currentUserEditMial: true })
  }

  resetCurrentUserUsername(singleUser) {
    this.setState({ visible: true, singleUser, currentUserEditUserName: true })
  }

  resetCurrentUserFirstName(singleUser) {
    this.setState({ visible: true, singleUser, currentUserEditFirstName: true })
  }

  resetCurrentUserLastName(singleUser) {
    this.setState({ visible: true, singleUser, currentUserEditLastName: true })
  }

  render() {
    const clientProfile = this.props.clientProfile;
    const isMakerChecker = this.props.clientProfile && this.props.clientProfile.maker_checker

    const { users } = this.props;
    const { currentUser } = this.props;
    const { MyClient } = this.props;
    const { 
      visible, createUser,

      reset, editMial, editUserName, editFirstName, editLastName, user,
      
      currentUserReset, currentUserEditMial,  currentUserEditUserName, 
      currentUserEditFirstName, currentUserEditLastName, singleUser, 

      Toggle_two_factor_authentication, two_factor_authentication,
      Toggle_display_device_logo, display_device_logo,
      Triger_add_logo, newLogo, newLogo_name, client_id
    } = this.state;
    
    const empty = _.isEmpty(users);
    const currentUserempty = _.isEmpty(currentUser);
    const MyClientempty = _.isEmpty(MyClient);

    // if(clientProfile && clientProfile.profile && clientProfile.profile.device_logo === null){
    //   const logo_url = clientProfile.profile.logo
    // }else{
    //   const logo_url = clientProfile.profile?.device_logo
    // }
    
    if (this.props.clientProfile && this.props.clientProfile.isFetching) {
      return <div className="loading">...</div>;
    }

    // console.log('||||||||||||||||||||||||||||||||||||')
    // console.log(clientProfile)
    // console.log(currentUser)
    // console.log(MyClient)
    
    return (
      <Page className="user-profile">
        <h5 id='User_Settings_title'>
          <Icon
            title="User Settings"
            name="user-circle-o"
            size="1.7rem"
          />
          User Settings
        </h5>
        <div id='User_Settings'>
          <table className="user-manage-table">
            <thead>
              <tr>
                <th>Username</th>
                <th>First Name</th>
                <th>Last Name</th>
                <th>Email Id</th>
                <th></th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {
                !currentUserempty && _.map(currentUser, (user_me, key) => (
                  <tr key={key}>
                    <td>
                      <Icon
                        title="Username"
                        name="edit"
                        size="1.35rem"
                        onClick={() => this.resetCurrentUserUsername(user_me.id)} 
                      />
                      {user_me.username}
                    </td>

                    <td>
                      <Icon
                        title="Firstname"
                        name="edit"
                        size="1.35rem"
                        onClick={() => this.resetCurrentUserFirstName(user_me.id)} 
                      />
                      {user_me.first_name}
                    </td>

                    <td>
                      <Icon
                        title="Lastname"
                        name="edit"
                        size="1.35rem"
                        onClick={() => this.resetCurrentUserLastName(user_me.id)} 
                      />
                      {user_me.last_name}
                    </td>

                    <td className='email_td'>
                      <Icon
                        title="Email"
                        name="edit"
                        size="1.35rem"
                        onClick={() => this.resetCurrentUserEmail(user_me.id)} 
                      />
                      {user_me.email}
                    </td>
                    <div className='artificial_td'><Button onClick={() => this.resetCurrentUserPassword(user_me.id)}>Reset Password</Button></div>
                  </tr>
                ))
              }
            </tbody>
          </table>
        </div>

        <h5 id='security_Settings_title'>
          <Icon
            title="Client Dashboard"
            name="user-shield"
            size="1.7rem"
          />
          Security Settings
        </h5>
        {clientProfile && clientProfile.features.two_factor_authentication? (
          !currentUserempty && _.map(currentUser, (user_me, key) => (
            <div id='security_Settings'>
              <Switch 
                checked={user_me.two_factor_authentication} 
                onChange={(e) => {
                  const singleUser = user_me.id
                  this.setState({ singleUser:user_me.id, two_factor_authentication: user_me.two_factor_authentication, Toggle_two_factor_authentication: true });
                }}
                size="tiny"
                formId={`two_factor_authentication-${user_me.id}`}
                label='Two Factor Authentication'
              />
            </div>
          ))
        ): null}

        {clientProfile && clientProfile.is_client_admin ? (
          <>
            <h5 id='Client_Dashboard_title'>
              <Icon
                title="Client Dashboard"
                name="cubes"
                size="1.7rem"
              />
              Client Dashboard Settings
            </h5>

            <div  id='Client_Dashboard'>

              {clientProfile.features.change_device_logo ? (
                !MyClientempty && _.map(MyClient, (client, key) => (
                  <div>
                    <input 
                      type="file" id="logo" name="logo" 
                      accept="image/*" 
                      onChange={(e) => {
                        this.setState({ client_id:client.id, newLogo_name: e.target.files[0].name, newLogo: e.target.files[0], Triger_add_logo: true });
                      }}
                    />

                    <label htmlFor="logo" id='logo_label'>
                      <div id='image_label_div_ovalay'>
                        <span>
                          <Icon
                            title="Add Logo"
                            name="circle-plus"
                            size="1.7rem"
                          />
                          {
                            newLogo == null? ('Add New Logo'):(newLogo_name)
                          }
                        </span>
                        
                        {
                          client.device_logo !== null? 
                          <img src={client.device_logo.replace("/api", "/app")} alt="" id='logo_img'/>:<img src={client.logo.replace("/api", "/app")} alt="" id='logo_img'/>
                        }
                        
                      </div>

                    </label>

                    <Switch 
                      checked={client.display_device_logo}
                      onChange={(e) => {
                        this.setState({ client_id:client.id, display_device_logo: client.display_device_logo, Toggle_display_device_logo: true });
                      }}
                      size="tiny"
                      formId={`Clients Id-${client.id}`}
                      label='Show Logo'
                    />
                  </div>
                ))
              ): null}
            </div>

            <h5  id='users_title'>
              <Icon
                title="Users Settings"
                name="users"
                size="1.7rem"
              />
              Users
            </h5>
            <div  id='users'>

              <table className="user-manage-table">
                <thead>
                  <tr>
                    <th>Username</th>
                    <th>First Name</th>
                    <th>Last Name</th>
                    <th>Email Id</th>
                    <th></th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    !empty && _.map(users, (user, key) => (
                      <tr key={key}>
                        <td>
                          <Icon
                            title="Username"
                            name="edit"
                            size="1.35rem"
                            onClick={() => this.resetUsername(user.id)} 
                          />
                          {user.username}
                        </td>

                        <td>
                          <Icon
                            title="Firstname"
                            name="edit"
                            size="1.35rem"
                            onClick={() => this.resetFirstName(user.id)} 
                          />
                          {user.first_name}
                        </td>

                        <td>
                          <Icon
                            title="Lastname"
                            name="edit"
                            size="1.35rem"
                            onClick={() => this.resetLastName(user.id)} 
                          />
                          {user.last_name}
                        </td>

                        <td className='email_td'>
                          <Icon
                            title="Email"
                            name="edit"
                            size="1.35rem"
                            onClick={() => this.resetEmail(user.id)} 
                          />
                          {user.email}
                        </td>
                        <div className='artificial_td'><Button onClick={() => this.resetPassword(user.id)}>Reset Password</Button></div>
                        <div className='artificial_td'><Button onClick={() => this.editUserPerms(user.id)}>Edit Permissions</Button></div>
                        <div className='artificial_td'>
                          <Icon
                            title="Delete"
                            name="trash-o"
                            size="1.5rem"
                            onClick={() => this.handleUserDelete(user)} 
                          />
                        </div>
                      </tr>
                    ))
                  }
                </tbody>
              </table>
              <Button onClick={() => this.createSubUser(user)} className='button'>
                Create User
              </Button>
            </div>
          </>
        ) : null}
        <PermissionModal 
        isMakerChecker={isMakerChecker}
          onCancel={this.handleCancel} visible={visible}  createUser={createUser} 
          

          reset={reset} editMial={editMial} editUserName={editUserName} 
          editFirstName={editFirstName} editLastName={editLastName} 
          userID={user} users={users}
          

          currentUserReset={currentUserReset} currentUserEditMial={currentUserEditMial} 
          currentUserEditUserName={currentUserEditUserName} currentUserEditFirstName={currentUserEditFirstName} 
          currentUserEditLastName={currentUserEditLastName} currentUserserID={singleUser} 
          currentUser={currentUser} two_factor_authentication={two_factor_authentication}
          Toggle_two_factor_authentication={Toggle_two_factor_authentication}
          display_device_logo={display_device_logo} Toggle_display_device_logo={Toggle_display_device_logo}
          newLogo={newLogo} Triger_add_logo={Triger_add_logo} client_id={client_id}
        />
      </Page> 
    );
  }
}

export default connect((state) => ({
  clientProfile: getProfile(state),
  users: getUsers(state),
  currentUser: getProfileUser(state),
  MyClient : getClient(state), 
}), {
  fetchClient, fetchUsers, fetchUserData, confirmationRequest, updateProfile, setPageTitle,
})(UserProfilePage);



// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./src/containers/UserProfilePage/index.js